import { Controller } from "../Controller";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { Item } from "../../HTML/Navigation/Item";
import { toMap } from "../../../../HA";

export class NavigationItem extends Controller {
    /**
     * @param data
     */
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        const hdata = new Map(data);
        hdata.set("-events", toMap({
            click: () => {
                this.click();
            },
        }));
        hdata.delete("click");
        this.createTag(hdata);

    }

    protected createTag(data: any) {
        this.addToData("tag", new Item(data));
    }
}

ControllerRegistry.register("NavigationItem", NavigationItem);
